import React from 'react';
import styled from "styled-components";
import TutorialSlider from "./TutorialSlider";
import TutorialFormBlock from "./TutorialFormBlock";
import TutorialInformationBlock from "./TutorialInformationBlock";

const Body: React.FC = () => {

    return (
        <Container>
            <H2>Codes</H2>
            <P>Tutorial mode: Now enter the code  in the field below</P>
            <TutorialFormBlock/>
            <P>Find symbols you’ve collected below. If you miss any, ask community</P>
            <TutorialSlider/>
            <TutorialInformationBlock/>
        </Container>
    );
};

export default Body;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    overflow-y: scroll;
`;
const H2 = styled.h2`
    padding: 0 24px;
    font-size: 32px;
    font-weight: 700;
    margin: 24px 0 5px;
    opacity: .7;
`;
const P = styled.p`
    font-size: 16px;
    font-weight: 700;
    opacity: .7;
    margin: 0;
    padding: 0 24px;
    color: #F1D988;
`
